module.exports = __webpack_public_path__ + "assets/img/VentureCrowd-Pillar-Page-Resource-w960.aef06798.webp";